/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Judge.me Spacing Override Script
function removeJudgeMeSpacing() {
  const reviewWidget = document.getElementById('judgeme_product_reviews');
  if (!reviewWidget) return;

  // Override CSS custom properties
  const spacingVars = [
    '--jm-space-300',
    '--jm-space-600', 
    '--jm-space-400',
    '--jm-space-200',
    '--jm-space-100',
    '--52156a25'
  ];

  spacingVars.forEach(varName => {
    reviewWidget.style.setProperty(varName, '0px', 'important');
  });

  // Remove spacing from most stack elements but keep some for readability
  const stackElements = reviewWidget.querySelectorAll('[class*="jm-stack"]');
  stackElements.forEach(el => {
    el.style.setProperty('--52156a25', '0px', 'important');
    
    // Keep minimal spacing for header alignment
    if (el.classList.contains('jm-review-widget__header')) {
      el.style.setProperty('gap', '8px', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0 0 8px 0', 'important');
    } else if (el.classList.contains('jm-review-item')) {
      // Add spacing between review items to prevent overlap
      el.style.setProperty('gap', '0', 'important');
      el.style.setProperty('margin', '16px 0', 'important');
      el.style.setProperty('padding', '12px', 'important');
    } else {
      el.style.setProperty('gap', '0', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0', 'important');
    }
  });

  // Fix header alignment
  const headerClusters = reviewWidget.querySelectorAll('.jm-review-widget__header .jm-cluster');
  headerClusters.forEach(cluster => {
    cluster.style.setProperty('align-items', 'center', 'important');
    cluster.style.setProperty('gap', '8px', 'important');
  });

  // Add spacing between review items in the list and fix alignment
  const reviewList = reviewWidget.querySelector('.jdgm-review-list');
  if (reviewList) {
    reviewList.style.setProperty('gap', '20px', 'important');
    reviewList.style.setProperty('margin', '0', 'important');
    reviewList.style.setProperty('padding', '0', 'important');
  }

  // Target individual review boxes for better separation and remove indentation
  const reviewBoxes = reviewWidget.querySelectorAll('.jm-box.jm-review-item');
  reviewBoxes.forEach(box => {
    box.style.setProperty('margin', '0 0 20px 0', 'important');
    box.style.setProperty('padding', '12px 0', 'important');
  });

  // Fix review widget body alignment
  const reviewBody = reviewWidget.querySelector('.jm-review-widget__body');
  if (reviewBody) {
    reviewBody.style.setProperty('margin', '0', 'important');
    reviewBody.style.setProperty('padding', '0', 'important');
  }

  // Make average rating text bold and add parentheses to review count
  const avgRatingTexts = reviewWidget.querySelectorAll('.jm-average-rating-display .jm-cluster .jm-text');
  if (avgRatingTexts.length >= 2) {
    // Make first text (rating) bold
    avgRatingTexts[0].style.setProperty('--text-weight', 'var(--jm-body-xs-weight-bold)', 'important');
    
    // Add parentheses around second text (review count)
    const reviewCountText = avgRatingTexts[1];
    if (reviewCountText && !reviewCountText.textContent.includes('(')) {
      reviewCountText.textContent = `(${reviewCountText.textContent})`;
    }
  }

  // Move "Write a review" button below average rating
  const headerCluster = reviewWidget.querySelector('.jm-review-widget__header .jm-cluster');
  if (headerCluster) {
    headerCluster.style.setProperty('flex-direction', 'column', 'important');
    headerCluster.style.setProperty('align-items', 'flex-start', 'important');
    headerCluster.style.setProperty('gap', '8px', 'important');
  }

  // Make filters narrower and shorter
  const filters = reviewWidget.querySelector('.jm-review-widget-minimal-header__filters');
  if (filters) {
    filters.style.setProperty('width', '34px', 'important');
    filters.style.setProperty('height', '34px', 'important');
  }

  // Make the dropdown select narrower
  const filterSelect = reviewWidget.querySelector('.jm-sort-filter__select');
  if (filterSelect) {
    filterSelect.style.setProperty('width', '30px', 'important');
    filterSelect.style.setProperty('height', '34px', 'important');
  }

  // Make Judge.me pagination less compact
  const paginationCluster = reviewWidget.querySelector('.jm-pagination-controls .jm-cluster');
  if (paginationCluster) {
    paginationCluster.style.setProperty('--cluster-space', '6px', 'important');
    paginationCluster.style.setProperty('gap', '6px', 'important');
  }

  // Add spacing to pagination buttons
  const paginationButtons = reviewWidget.querySelectorAll('.jm-pagination-controls__button');
  paginationButtons.forEach(button => {
    button.style.setProperty('margin', '0 2px', 'important');
    button.style.setProperty('padding', '9px 9px', 'important');
  });
}

// Fix image progress dots stretching bug
function fixProgressDots() {
  // Add CSS rule to override all possible dot stretching
  let styleSheet = document.getElementById('dot-fix-styles');
  if (!styleSheet) {
    styleSheet = document.createElement('style');
    styleSheet.id = 'dot-fix-styles';
    document.head.appendChild(styleSheet);
  }
  
  styleSheet.textContent = `
    /* Fix dot containers from expanding */
    [class*="pagination"],
    [class*="dots"],
    .product-gallery__pagination,
    .slideshow__pagination,
    .flickity-page-dots,
    .splide__pagination,
    .swiper-pagination {
      width: auto !important;
      max-width: none !important;
      flex-shrink: 0 !important;
      justify-content: center !important;
    }
    
    /* Force all potential dot elements to maintain size */
    [class*="pagination"] button,
    [class*="dots"] button,
    [class*="dot"],
    .product-gallery button,
    .slideshow button,
    .flickity-page-dots .dot,
    .splide__pagination button,
    .swiper-pagination-bullet {
      width: 8px !important;
      height: 8px !important;
      min-width: 8px !important;
      min-height: 8px !important;
      max-width: 8px !important;
      max-height: 8px !important;
      flex-shrink: 0 !important;
      flex-grow: 0 !important;
      flex-basis: 8px !important;
      border-radius: 50% !important;
      transition: none !important;
      transform: none !important;
      box-sizing: border-box !important;
      margin: 2px !important;
    }
    
    /* Override any active/hover states that might stretch */
    [class*="pagination"] button.is-selected,
    [class*="pagination"] button:hover,
    [class*="dots"] button.is-selected,
    [class*="dots"] button:hover,
    [class*="dot"].is-selected,
    [class*="dot"]:hover {
      width: 8px !important;
      height: 8px !important;
      transform: none !important;
    }
  `;
}

// Run when DOM loads and when Judge.me widgets update
document.addEventListener('DOMContentLoaded', () => {
  removeJudgeMeSpacing();
  fixProgressDots();
});
document.addEventListener('judgeme:loaded', removeJudgeMeSpacing);

// Fix dots on scroll and resize events
let scrollTimeout;
window.addEventListener('scroll', () => {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(fixProgressDots, 50);
});

window.addEventListener('resize', fixProgressDots);

// Use intersection observer to fix dots when they come into view
const dotObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      setTimeout(fixProgressDots, 100);
    }
  });
});

// Observe dot containers
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const dotContainers = document.querySelectorAll('[class*="dots"], [class*="progress-dots"], .product-gallery__pagination, .slideshow__pagination');
    dotContainers.forEach(container => {
      dotObserver.observe(container);
    });
  }, 1000);
});

// Use MutationObserver to handle dynamic content
const observer = new MutationObserver(() => {
  removeJudgeMeSpacing();
});

document.addEventListener('DOMContentLoaded', () => {
  const reviewWidget = document.getElementById('judgeme_product_reviews');
  if (reviewWidget) {
    observer.observe(reviewWidget, { childList: true, subtree: true });
  }
});
